/**
 * Reglas de validacion de formularios, en un solo lugar.
 *
 * Vivian dentro de RegistreView. Al escribir la vista de recuperacion hacian
 * falta las mismas dos (correo y clave), y copiarlas habria dejado dos juegos
 * de reglas que se desincronizan el dia que cambie cualquiera de las dos.
 *
 * Son las mismas que aplica el backend en UserController.save y en
 * UserService.validatePassword. Se repiten aqui a proposito: si el usuario las
 * descubre de a una con errores del servidor, abandona el formulario. Cuando
 * cambien alla, cambian aqui.
 *
 * Cada regla devuelve true si el valor sirve, o el mensaje de error. Es la
 * forma que esperan los :rules y los :error-messages de Vuetify.
 *
 * OJO: usarlas siempre fuera de data(). Declaradas dentro, Vue las envuelve en
 * un proxy reactivo, Vuetify deja de reevaluarlas y el mensaje de error se
 * queda pegado aunque el usuario ya haya corregido el campo.
 */

export const REQUERIDO = v => (v !== null && v !== undefined && String(v).trim() !== '') || 'Campo obligatorio';

export const CORREO = v => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v || '') || 'Correo no válido';

export const MAYOR_DE_EDAD = v => Number(v) >= 18 || 'Debes ser mayor de 18 años';

export const CLAVE = v => (String(v || '').length >= 5 && /[A-Za-z]/.test(v || '') && /\d/.test(v || ''))
  || 'Mínimo 5 caracteres, con al menos una letra y un número';
